/**
 * Le catalogue d'emojis unicode du cockpit — DONNÉE PURE, aucun import.
 *
 * Extrait d'`EmojiPicker.tsx` le 18-08-2026 pour qu'une surface PUBLIQUE
 * puisse l'utiliser. Le picker complet, lui, ne peut pas s'y monter : il tire
 * `useCustomEmojiCatalog()` (une requête authentifiée) et les emojis Premium
 * de la créatrice. L'épreuve de candidature n'a ni compte ni créatrice.
 *
 * 🎯 Séparer la donnée du composant est ce qui évite la copie. Une liste
 * recopiée dans l'épreuve aurait divergé au premier emoji ajouté ici, et le
 * candidat se serait entraîné sur un clavier qui n'est pas celui du poste.
 * Même geste que pour `AttachMenu` (rendu réutilisable en rendant ses entrées
 * facultatives) et pour les sections de la doc du chatteur.
 *
 * ⚠️ Ce module ne doit JAMAIS importer quoi que ce soit. C'est cette propriété,
 * et elle seule, qui le rend montable sur une page sans session.
 */

export const CATEGORIES = [
  {
    key: "smileys",
    label: "😀",
    emojis: [
      "😀", "😃", "😄", "😁", "😆", "😅", "🤣", "😂",
      "🙂", "🙃", "😉", "😊", "😇", "🥰", "😍", "🤩",
      "😘", "😗", "😚", "😙", "😋", "😛", "😜", "🤪",
      "😝", "🤑", "🤗", "🤭", "🤔", "🤐", "🤨", "😐",
      "😑", "😶", "😏", "😒", "🙄", "😬", "😌", "😔",
      "😪", "🤤", "😴", "😷", "🤒", "🤕", "🤢", "🤮",
      "🥶", "🥵", "😎", "🤓", "🧐", "🥳",
    ],
  },
  {
    key: "emotions",
    label: "😢",
    emojis: [
      "😕", "😟", "🙁", "☹️", "😮", "😯", "😲", "😳",
      "🥺", "😦", "😧", "😨", "😰", "😥", "😢", "😭",
      "😱", "😖", "😣", "😞", "😓", "😩", "😫", "🥱",
      "😤", "😡", "😠", "🤬", "😈", "👿", "💀", "☠️",
    ],
  },
  {
    key: "hearts",
    label: "❤️",
    emojis: [
      "❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍",
      "🤎", "💔", "❣️", "💕", "💞", "💓", "💗", "💖",
      "💘", "💝", "💟", "💌", "💋", "👀", "💯", "✨",
      "💫", "⭐", "🌟", "💥", "🔥", "💦", "💨", "🌹",
    ],
  },
  {
    key: "gestures",
    label: "👍",
    emojis: [
      "👍", "👎", "👌", "🤌", "🤏", "✌️", "🤞", "🫰",
      "🤟", "🤘", "🤙", "👈", "👉", "👆", "🖕", "👇",
      "☝️", "👋", "🤚", "🖐️", "✋", "🖖", "👏", "🙌",
      "🤝", "🙏", "✊", "👊", "🤛", "🤜", "💪", "🫶",
    ],
  },
  {
    key: "animals_food",
    label: "🐶",
    emojis: [
      "🐶", "🐱", "🐭", "🐹", "🐰", "🦊", "🐻", "🐼",
      "🦁", "🐮", "🐷", "🐵", "🐸", "🐔", "🐧", "🦄",
      "🍕", "🍔", "🍟", "🌭", "🥪", "🍿", "🍩", "🍪",
      "🎂", "🍰", "🍫", "🍬", "🍭", "🍦", "🍓", "🍉",
      "🍇", "🍒", "🍑", "🥑", "🌮", "🍣", "🍝", "🥂",
      "🍾", "🍷", "🍸", "🍹", "🍺", "🍻", "🥃", "☕",
    ],
  },
  {
    key: "symbols",
    label: "🎉",
    emojis: [
      "🎉", "🎊", "🎁", "🎈", "🎀", "🎂", "🥳", "🎵",
      "🎶", "🎸", "🎤", "🎬", "📸", "📱", "💎", "👑",
      "💰", "💵", "💸", "🏆", "🥇", "🥈", "🥉", "🚀",
      "✈️", "🌍", "🌙", "☀️", "⛅", "❄️", "⚡", "🌈",
      "🆗", "✅", "❌", "⛔", "🚫", "💢", "❓", "❗",
    ],
  },
] as const;
